import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "axios";
import "./AlumniRegister.css";
import { Alertmessage } from "../../widgets";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_\-+=]).{8,}$/;

// Common country codes; add more as needed
const COUNTRY_CODES = [
  { code: "+93", country: "Afghanistan" },
  { code: "+355", country: "Albania" },
  { code: "+213", country: "Algeria" },
  { code: "+1684", country: "American Samoa" },
  { code: "+376", country: "Andorra" },
  { code: "+244", country: "Angola" },
  { code: "+1264", country: "Anguilla" },
  { code: "+1268", country: "Antigua and Barbuda" },
  { code: "+54", country: "Argentina" },
  { code: "+374", country: "Armenia" },
  { code: "+297", country: "Aruba" },
  { code: "+61", country: "Australia" },
  { code: "+43", country: "Austria" },
  { code: "+994", country: "Azerbaijan" },
  { code: "+1242", country: "Bahamas" },
  { code: "+973", country: "Bahrain" },
  { code: "+880", country: "Bangladesh" },
  { code: "+1246", country: "Barbados" },
  { code: "+375", country: "Belarus" },
  { code: "+32", country: "Belgium" },
  { code: "+501", country: "Belize" },
  { code: "+229", country: "Benin" },
  { code: "+1441", country: "Bermuda" },
  { code: "+975", country: "Bhutan" },
  { code: "+591", country: "Bolivia" },
  { code: "+387", country: "Bosnia and Herzegovina" },
  { code: "+267", country: "Botswana" },
  { code: "+55", country: "Brazil" },
  { code: "+673", country: "Brunei" },
  { code: "+359", country: "Bulgaria" },
  { code: "+226", country: "Burkina Faso" },
  { code: "+257", country: "Burundi" },
  { code: "+855", country: "Cambodia" },
  { code: "+237", country: "Cameroon" },
  { code: "+1", country: "Canada" },
  { code: "+238", country: "Cape Verde" },
  { code: "+1345", country: "Cayman Islands" },
  { code: "+236", country: "Central African Republic" },
  { code: "+235", country: "Chad" },
  { code: "+56", country: "Chile" },
  { code: "+86", country: "China" },
  { code: "+57", country: "Colombia" },
  { code: "+269", country: "Comoros" },
  { code: "+243", country: "Congo (DRC)" },
  { code: "+242", country: "Congo (Republic)" },
  { code: "+682", country: "Cook Islands" },
  { code: "+506", country: "Costa Rica" },
  { code: "+385", country: "Croatia" },
  { code: "+53", country: "Cuba" },
  { code: "+357", country: "Cyprus" },
  { code: "+420", country: "Czech Republic" },
  { code: "+45", country: "Denmark" },
  { code: "+253", country: "Djibouti" },
  { code: "+1767", country: "Dominica" },
  { code: "+1809", country: "Dominican Republic" },
  { code: "+593", country: "Ecuador" },
  { code: "+20", country: "Egypt" },
  { code: "+503", country: "El Salvador" },
  { code: "+240", country: "Equatorial Guinea" },
  { code: "+291", country: "Eritrea" },
  { code: "+372", country: "Estonia" },
  { code: "+251", country: "Ethiopia" },
  { code: "+679", country: "Fiji" },
  { code: "+358", country: "Finland" },
  { code: "+33", country: "France" },
  { code: "+241", country: "Gabon" },
  { code: "+220", country: "Gambia" },
  { code: "+995", country: "Georgia" },
  { code: "+49", country: "Germany" },
  { code: "+233", country: "Ghana" },
  { code: "+350", country: "Gibraltar" },
  { code: "+30", country: "Greece" },
  { code: "+1473", country: "Grenada" },
  { code: "+1671", country: "Guam" },
  { code: "+502", country: "Guatemala" },
  { code: "+224", country: "Guinea" },
  { code: "+245", country: "Guinea-Bissau" },
  { code: "+592", country: "Guyana" },
  { code: "+509", country: "Haiti" },
  { code: "+504", country: "Honduras" },
  { code: "+852", country: "Hong Kong" },
  { code: "+36", country: "Hungary" },
  { code: "+354", country: "Iceland" },
  { code: "+91", country: "India" },
  { code: "+62", country: "Indonesia" },
  { code: "+98", country: "Iran" },
  { code: "+964", country: "Iraq" },
  { code: "+353", country: "Ireland" },
  { code: "+972", country: "Israel" },
  { code: "+39", country: "Italy" },
  { code: "+1876", country: "Jamaica" },
  { code: "+81", country: "Japan" },
  { code: "+962", country: "Jordan" },
  { code: "+7", country: "Kazakhstan" },
  { code: "+254", country: "Kenya" },
  { code: "+686", country: "Kiribati" },
  { code: "+965", country: "Kuwait" },
  { code: "+996", country: "Kyrgyzstan" },
  { code: "+856", country: "Laos" },
  { code: "+371", country: "Latvia" },
  { code: "+961", country: "Lebanon" },
  { code: "+266", country: "Lesotho" },
  { code: "+231", country: "Liberia" },
  { code: "+218", country: "Libya" },
  { code: "+423", country: "Liechtenstein" },
  { code: "+370", country: "Lithuania" },
  { code: "+352", country: "Luxembourg" },
  { code: "+853", country: "Macau" },
  { code: "+389", country: "Macedonia" },
  { code: "+261", country: "Madagascar" },
  { code: "+265", country: "Malawi" },
  { code: "+60", country: "Malaysia" },
  { code: "+960", country: "Maldives" },
  { code: "+223", country: "Mali" },
  { code: "+356", country: "Malta" },
  { code: "+692", country: "Marshall Islands" },
  { code: "+222", country: "Mauritania" },
  { code: "+230", country: "Mauritius" },
  { code: "+52", country: "Mexico" },
  { code: "+691", country: "Micronesia" },
  { code: "+373", country: "Moldova" },
  { code: "+377", country: "Monaco" },
  { code: "+976", country: "Mongolia" },
  { code: "+382", country: "Montenegro" },
  { code: "+1664", country: "Montserrat" },
  { code: "+212", country: "Morocco" },
  { code: "+258", country: "Mozambique" },
  { code: "+95", country: "Myanmar" },
  { code: "+264", country: "Namibia" },
  { code: "+674", country: "Nauru" },
  { code: "+977", country: "Nepal" },
  { code: "+31", country: "Netherlands" },
  { code: "+64", country: "New Zealand" },
  { code: "+505", country: "Nicaragua" },
  { code: "+227", country: "Niger" },
  { code: "+234", country: "Nigeria" },
  { code: "+683", country: "Niue" },
  { code: "+850", country: "North Korea" },
  { code: "+47", country: "Norway" },
  { code: "+968", country: "Oman" },
  { code: "+92", country: "Pakistan" },
  { code: "+680", country: "Palau" },
  { code: "+970", country: "Palestine" },
  { code: "+507", country: "Panama" },
  { code: "+675", country: "Papua New Guinea" },
  { code: "+595", country: "Paraguay" },
  { code: "+51", country: "Peru" },
  { code: "+63", country: "Philippines" },
  { code: "+48", country: "Poland" },
  { code: "+351", country: "Portugal" },
  { code: "+1787", country: "Puerto Rico" },
  { code: "+974", country: "Qatar" },
  { code: "+40", country: "Romania" },
  { code: "+7", country: "Russia" },
  { code: "+250", country: "Rwanda" },
  { code: "+1869", country: "Saint Kitts and Nevis" },
  { code: "+1758", country: "Saint Lucia" },
  { code: "+1784", country: "Saint Vincent and the Grenadines" },
  { code: "+685", country: "Samoa" },
  { code: "+378", country: "San Marino" },
  { code: "+239", country: "Sao Tome and Principe" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+221", country: "Senegal" },
  { code: "+381", country: "Serbia" },
  { code: "+248", country: "Seychelles" },
  { code: "+232", country: "Sierra Leone" },
  { code: "+65", country: "Singapore" },
  { code: "+421", country: "Slovakia" },
  { code: "+386", country: "Slovenia" },
  { code: "+677", country: "Solomon Islands" },
  { code: "+252", country: "Somalia" },
  { code: "+27", country: "South Africa" },
  { code: "+82", country: "South Korea" },
  { code: "+211", country: "South Sudan" },
  { code: "+34", country: "Spain" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+249", country: "Sudan" },
  { code: "+597", country: "Suriname" },
  { code: "+268", country: "Swaziland (Eswatini)" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+963", country: "Syria" },
  { code: "+886", country: "Taiwan" },
  { code: "+992", country: "Tajikistan" },
  { code: "+255", country: "Tanzania" },
  { code: "+66", country: "Thailand" },
  { code: "+670", country: "Timor-Leste" },
  { code: "+228", country: "Togo" },
  { code: "+676", country: "Tonga" },
  { code: "+1868", country: "Trinidad and Tobago" },
  { code: "+216", country: "Tunisia" },
  { code: "+90", country: "Turkey" },
  { code: "+993", country: "Turkmenistan" },
  { code: "+1649", country: "Turks and Caicos Islands" },
  { code: "+688", country: "Tuvalu" },
  { code: "+256", country: "Uganda" },
  { code: "+380", country: "Ukraine" },
  { code: "+971", country: "UAE" },
  { code: "+44", country: "United Kingdom" },
  { code: "+1", country: "USA" },
  { code: "+598", country: "Uruguay" },
  { code: "+998", country: "Uzbekistan" },
  { code: "+678", country: "Vanuatu" },
  { code: "+379", country: "Vatican City" },
  { code: "+58", country: "Venezuela" },
  { code: "+84", country: "Vietnam" },
  { code: "+967", country: "Yemen" },
  { code: "+260", country: "Zambia" },
  { code: "+263", country: "Zimbabwe" },
];

const BRANCH_OPTIONS = ["CSE", "ECE", "EEE", "MCA", "MECH", "Others"];

const AlumniRegister = () => {
  const [isAlumni, setIsAlumni] = useState("");
  const [form, setForm] = useState({
    name: "",
    batch: "",
    branch: "",
    branchOther: "",
    countryCode: "+91",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    batch: "",
    branch: "",
    mobile: "",
    countryCode: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const batchOptions = Array.from({ length: 2025 - 1967 + 1 }, (_, index) => 2025 - index);

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "mobile") {
      value = value.replace(/\D/g, "").slice(0, 15);
    }
    if (name === "batch") {
      value = value.replace(/\D/g, "").slice(0, 4);
    }
    if (name === "name") {
      // Prevent numbers and special characters in name
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }
    if (name === "branchOther") {
      // Only letters, spaces, and & / . - allowed (no numbers)
      value = value.replace(/[^a-zA-Z\s&/.-]/g, "");
    }

    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "", form: "" }));
  };

  const validateForm = () => {
    const nextErrors = {};

    if (!isAlumni) {
      nextErrors.isAlumni = "Please select whether you are an alumni";
    }

    // 1. name — required, min 2 characters, only letters and spaces
    if (!form.name.trim()) {
      nextErrors.name = "Full name is required";
    } else if (form.name.trim().length < 2) {
      nextErrors.name = "Full name must be at least 2 characters";
    } else if (!/^[a-zA-Z\s]+$/.test(form.name.trim())) {
      nextErrors.name = "Full name can only contain letters and spaces";
    }

    if (isAlumni === "yes") {
      // 2. batch — required, cannot be empty
      if (!form.batch) {
        nextErrors.batch = "Batch is required";
      }

      // 3. branch — required, cannot be empty
      if (!form.branch) {
        nextErrors.branch = "Branch is required";
      } else if (form.branch === "Others" && !form.branchOther.trim()) {
        nextErrors.branch = "Please specify your branch";
      }
    }

    // 4. country code — required
    if (!form.countryCode) {
      nextErrors.countryCode = "Country code is required";
    }

    // 5. mobile — required, digits only, reasonable length
    if (!form.mobile.trim()) {
      nextErrors.mobile = "Mobile number is required";
    } else if (!/^\d{4,15}$/.test(form.mobile.trim())) {
      nextErrors.mobile = "Enter a valid mobile number";
    }

    // 6. email — required, valid email format
    if (!form.email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!EMAIL_REGEX.test(form.email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

    // 7. password — required, min 8 characters, at least 1 uppercase, 1 lowercase, 1 number
    if (!form.password) {
      nextErrors.password = "Password is required";
    } else if (form.password.length < 8) {
      nextErrors.password = "Password must be at least 8 characters";
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(form.password)) {
      nextErrors.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number";
    }

    // 8. confirmPassword — required, must exactly match password
    if (!form.confirmPassword) {
      nextErrors.confirmPassword = "Confirm password is required";
    } else if (form.password !== form.confirmPassword) {
      nextErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleClose = () => {
    setAlertMessage("");
    if (isSuccess) {
      navigate("/alumni-login", { replace: true });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const finalBranch = form.branch === "Others" ? form.branchOther.trim() : form.branch;

    setIsSubmitting(true);
    try {
      const response = await axios.post("/backend/alumni/register/send-otp", {
        fullname: form.name.trim(),
        batch: isAlumni === "yes" ? form.batch : null,
        branch: isAlumni === "yes" ? finalBranch : null,
        phone: `${form.countryCode}${form.mobile.trim()}`,
        email: form.email.trim(),
        password: form.password,
        is_alumni: isAlumni === "yes",
      });

      if (response.status === 200 || response.status === 201) {
        navigate("/alumni-register-verify", {
          state: {
            email: form.email.trim(),
          },
        });

        return;
      }
    } catch (error) {
      console.error(error);
      const msg = error.response?.data?.message || "Registration failed. Please check details.";
      setAlertMessage(msg);
      setIsSuccess(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderFieldError = (field) => (errors[field] ? <p className="alumni-field-error">{errors[field]}</p> : null);

  return (
    <div className="alumni-login-page alumni-login-shell">
      <style>{`
        .alumni-phone-box {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
        }
        .alumni-country-select {
          flex: 0 0 130px;
          width: 130px;
          min-width: 130px;
        }
        .alumni-mobile-input {
          flex: 1 1 auto;
          min-width: 0;
          width: 100%;
        }
      `}</style>
      <div className="alumni-login-card alumni-register-card">
        <div className="alumni-card-accent"></div>
        <p className="alumni-page-eyebrow">PJC Alumni Fund</p>
        <h1 className="alumni-login-title">REGISTER</h1>
        <div className="alumni-login-line"></div>

        {formMessage && <div className="alumni-form-banner success">{formMessage}</div>}
        {errors.form && <div className="alumni-form-banner error">{errors.form}</div>}

        <form onSubmit={handleSubmit}>
          {!isAlumni && (
            <div className="alumni-input-group">
              <label>Are you alumni?</label>
              <div className="alumni-toggle-group">
                <button
                  type="button"
                  className={`alumni-toggle-btn ${isAlumni === "yes" ? "active" : ""}`}
                  onClick={() => {
                    setIsAlumni("yes");
                    setErrors((prev) => ({ ...prev, isAlumni: "" }));
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={`alumni-toggle-btn ${isAlumni === "no" ? "active" : ""}`}
                  onClick={() => {
                    setIsAlumni("no");
                    setErrors((prev) => ({ ...prev, isAlumni: "" }));
                  }}
                >
                  No
                </button>
              </div>
              {renderFieldError("isAlumni")}
            </div>
          )}

          {isAlumni && (
            <>
              <div className="alumni-input-group">
                <label htmlFor="name">Full Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter your full name"
                  value={form.name}
                  onChange={handleChange}
                  aria-invalid={Boolean(errors.name)}
                />
                {renderFieldError("name")}
              </div>

              {isAlumni === "yes" && (
                <>
                  <div className="alumni-input-group">
                    <label htmlFor="batch">Batch (Year of Passing)</label>
                    <select
                      id="batch"
                      name="batch"
                      value={form.batch}
                      onChange={handleChange}
                      aria-invalid={Boolean(errors.batch)}
                    >
                      <option value="">Select batch year</option>
                      {batchOptions.map((year) => (
                        <option key={year} value={String(year)}>
                          {year}
                        </option>
                      ))}
                    </select>
                    {renderFieldError("batch")}
                  </div>

                  <div className="alumni-input-group">
                    <label htmlFor="branch">Branch</label>
                    <select
                      id="branch"
                      name="branch"
                      value={form.branch}
                      onChange={handleChange}
                      aria-invalid={Boolean(errors.branch)}
                    >
                      <option value="" disabled hidden>Select branch</option>
                      {BRANCH_OPTIONS.map((b) => (
                        <option key={b} value={b}>
                          {b}
                        </option>
                      ))}
                    </select>
                    {form.branch === "Others" && (
                      <input
                        id="branchOther"
                        name="branchOther"
                        type="text"
                        placeholder="Please specify your branch"
                        value={form.branchOther}
                        onChange={handleChange}
                        style={{ marginTop: "8px" }}
                      />
                    )}
                    {renderFieldError("branch")}
                  </div>
                </>
              )}

              <div className="alumni-input-group">
                <label htmlFor="mobile">Mobile Number</label>
                <div className="alumni-phone-box">
                  <select
                    id="countryCode"
                    name="countryCode"
                    value={form.countryCode}
                    onChange={handleChange}
                    aria-invalid={Boolean(errors.countryCode)}
                    className="alumni-country-select"
                  >
                    {COUNTRY_CODES.map(({ code, country }) => (
                      <option key={code} value={code}>
                        {code} ({country})
                      </option>
                    ))}
                  </select>

                  <input
                    id="mobile"
                    name="mobile"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your mobile number"
                    value={form.mobile}
                    onChange={handleChange}
                    aria-invalid={Boolean(errors.mobile)}
                    className="alumni-mobile-input"
                  />
                </div>
                {renderFieldError("countryCode")}
                {renderFieldError("mobile")}
              </div>

              <div className="alumni-input-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  aria-invalid={Boolean(errors.email)}
                />
                {renderFieldError("email")}
              </div>

              <div className="alumni-input-group">
                <label htmlFor="password">Password</label>
                <div className="alumni-password-box">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Create a password"
                    value={form.password}
                    onChange={handleChange}
                    aria-invalid={Boolean(errors.password)}
                  />
                  <button
                    type="button"
                    className="alumni-eye-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOffOutline size={22} /> : <FaRegEye size={20} />}
                  </button>
                </div>
                {renderFieldError("password")}
              </div>

              <div className="alumni-input-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <div className="alumni-password-box">
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm your password"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    aria-invalid={Boolean(errors.confirmPassword)}
                  />
                  <button
                    type="button"
                    className="alumni-eye-btn"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <IoEyeOffOutline size={22} /> : <FaRegEye size={20} />}
                  </button>
                </div>
                {renderFieldError("confirmPassword")}
              </div>

              <button type="submit" className="alumni-login-btn" disabled={isSubmitting}>
                Create account
              </button>

              <div className="alumni-register-text">
                Already have an account? <Link to="/alumni-login">Login</Link>
              </div>
            </>
          )}
        </form>
      </div>
      <Alertmessage message={alertMessage} onClose={handleClose} />
    </div>
  );
};

export default AlumniRegister;